// Copyright 2021-present the Fonction authors. All rights reserved. MIT license.
export { _ } from 'https://x.nest.land/arithmetic4@0.1.1/mod.ts'
export const NULL = null
export const JSON_OBJECT = 'Object'

const { prototype } = Object
const { hasOwnProperty } = prototype

export { hasOwnProperty }
